import { graphql } from "relay-runtime"

export const deUpdateProgressNoteAnamnesis = graphql`
  mutation deUpdateProgressNoteAnamnesisMutation($input: De_updateProgressNoteAnamnesisInput!) {
    de_updateProgressNoteAnamnesis(input: $input) {
      de_ProgressNoteMutationOutput {
        episodeOfCare {
          id
          updatedAt
        }
        progressNote {
          anamnesis
          updatedAt
        }
      }
    }
  }
`
